import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {GoogleOAuthProvider} from '@react-oauth/google';
import App from './App.tsx';
import './index.css';

const DEFAULT_GOOGLE_CLIENT_ID = '937054100075-s2caqudl2n75of6f8g7oo665ejsusbb9.apps.googleusercontent.com';
const envClientId = ((import.meta as any).env?.VITE_GOOGLE_CLIENT_ID as string) || '';
const initialClientId = envClientId || (typeof localStorage !== 'undefined' ? localStorage.getItem('progress_custom_google_client_id') : '') || DEFAULT_GOOGLE_CLIENT_ID;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={initialClientId}>
      <App />
    </GoogleOAuthProvider>
  </StrictMode>,
);

